import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = (user?.name || '?')
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const links = {
    admin: [
      { to: '/admin', label: 'Dashboard' },
      { to: '/admin/courses', label: 'Courses' },
      { to: '/admin/users', label: 'Users' },
      { to: '/admin/enrollments', label: 'Enrollments' },
      { to: '/admin/certifications', label: 'Certifications' },
      { to: '/admin/certificates', label: 'Issued Certs' },
    ],
    trainer: [
      { to: '/trainer', label: 'Dashboard' },
      { to: '/trainer/courses', label: 'My Courses' },
      { to: '/trainer/students', label: 'Students' },
      { to: '/trainer/certificates', label: 'Certificates' },
    ],
    user: [
      { to: '/dashboard', label: 'Dashboard' },
      { to: '/courses', label: 'Browse Courses' },
      { to: '/my-courses', label: 'My Courses' },
      { to: '/my-certificates', label: 'Certificates' },
    ],
  };

  const userLinks = links[user?.role] || [];

  return (
    <nav className="navbar">
      <Link to="/" className="brand">
        <img src={"https://www.hillboat.com/assets/logotext-BkzMMB-0.svg"} alt="HillBoat Study" className="logo" width="20%" />
      </Link>
      {user && (
        <div className="nav-links">
          {userLinks.map((l) => (
            <NavLink key={l.to} to={l.to} end>
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
      {user ? (
        <div className="flex gap-2 items-center">
          <div className="user-chip">
            <div className="avatar">{initials}</div>
            <span>{user.name}</span>
            <span className={`badge badge-${user.role}`}>{user.role}</span>
          </div>
          <button className="btn btn-secondary btn-sm" onClick={handleLogout}>
            Logout
          </button>
        </div>
      ) : (
        <div className="flex gap-1">
          <Link to="/login" className="btn btn-secondary btn-sm">Login</Link>
          <Link to="/register" className="btn btn-primary btn-sm">Sign up</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
